// Общие мелочи API-обёрток справочников (план 108, Ф4).

export interface ListParams {
  includeArchived?: boolean;
}

/** ?includeArchived=true либо пустая строка. */
export function archivedQuery(params: ListParams): string {
  const sp = new URLSearchParams();
  if (params.includeArchived) sp.set('includeArchived', 'true');
  const qs = sp.toString();
  return qs ? `?${qs}` : '';
}

/** Payload без undefined-ключей: strict-DTO не любит лишние ключи. */
export function defined<T extends Record<string, unknown>>(obj: T): Partial<T> {
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(obj)) if (v !== undefined) out[k] = v;
  return out as Partial<T>;
}
